import useAuthenticatedRequest from '@Infowijs-eng/component-library/hooks/useAuthenticatedRequest'
import { useQuery } from '@tanstack/react-query'
import getBruggerEndpoint from '../../modules/getBruggerEndpoint'
import { OrganisationalUnit } from '../../types'

export default function useMagisterLocations(customerProductName: string) {
  const fetch = useAuthenticatedRequest()

  const bruggerEndpoint = customerProductName ? getBruggerEndpoint(customerProductName) : undefined

  return useQuery({
    queryKey: ['magister-locations', customerProductName],
    queryFn: async () => {
      const response = await fetch(`${bruggerEndpoint}/api/exporters/organisations`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response.data as OrganisationalUnit[]
    },
    enabled: !!customerProductName,

  })
}
